@if (month === 1) {
  <div class="new-year-message">
    <span class="firework"></span>
    <span class="year">{{ year }}</span>
    <span class="firework"></span>
  </div>
}
@if (month === 2) {
  <ul class="hearts">
    @for (light of [].constructor(25); track light) {
      <li>
        <span class="left-round"></span>
        <span class="right-round"></span>
      </li>
    }
  </ul>
}
@if (month === 10) {
  <div class="spiderweb"></div>
  <div class="spider">
    <div class="body">
      <div class="eye left"></div>
      <div class="eye right"></div>
    </div>
    <div class="legs left">
      @for (leg of [].constructor(4); track leg) {
        <div class="leg"></div>
      }
    </div>
    <div class="legs right">
      @for (leg of [].constructor(4); track leg) {
        <div class="leg"></div>
      }
    </div>
  </div>
}
@if (month === 12) {
  <ul class="strand">
    @for (light of [].constructor(43); track light) {
      <li></li>
    }
  </ul>
}
